module.exports = __webpack_public_path__ + "static/img/眼睛.4f45e86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/眼睛.png
// module id = a6KX
// module chunks = 1